var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import styled from "styled-components";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import { useTypedSelector } from "../../state/store";
import { withMargin } from "../styleComponents";
import MarkdownText from "../MarkdownText";
var Guidance = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var PeerReviewsGuidance = function PeerReviewsGuidance(_a) {
  var _b;
  var givenLabel = _a.givenLabel,
    guidanceText = _a.guidanceText,
    peerReviewsCompletedInfo = _a.peerReviewsCompletedInfo,
    instructionStartRef = _a.instructionStartRef;
  var themeProvider = React.useContext(ThemeProviderContext);
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var given = (_b = userQuizState === null || userQuizState === void 0 ? void 0 : userQuizState.peerReviewsGiven) !== null && _b !== void 0 ? _b : 0;
  var required = quiz && quiz.course.minPeerReviewsGiven || 0;
  var GivenCount = styled.b(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1.5rem;\n  "], ["\n    font-size: 1.5rem;\n  "])));
  var Instructions = withMargin(MarkdownText, "1.5rem 0 0 ");
  React.useEffect(function () {
    return console.log("Title rerenders");
  });
  return React.createElement(Guidance, {
    ref: instructionStartRef,
    providedStyles: themeProvider.peerReviewGuidanceStyles
  }, React.createElement(GivenCount, {
    class: "scroll-here-when-peer-review-starts"
  }, givenLabel, ": ", given, "/", required), React.createElement(Instructions, {
    Component: "p"
  }, guidanceText));
};
export default PeerReviewsGuidance;
var templateObject_1, templateObject_2;